import React, { useState, useEffect } from 'react';

import { Modal, BlockStack, Text, TextField, Checkbox } from '@shopify/polaris';

const EditUserDialog = ({ activeUser, displayEditUserDialog, setDisplayEditUserDialog, updateUser, setSubmitted }) => {
  const [loginName, setLoginName] = useState('');
  const [picker, setPicker] = useState(false);
  const [packer, setPacker] = useState(false);
  const [stockReturn, setStockReturn] = useState(false);

  useEffect(() => {
    setLoginName(activeUser.loginName);
    setPicker(activeUser.picker);
    setPacker(activeUser.packer);
    setStockReturn(activeUser.stockReturn);
  }, [activeUser]);

  const submit = () => {
    updateUser({
      email: activeUser.email,
      login_name: loginName,
      permissions: {
        picker: picker,
        packer: packer,
        stock_return: stockReturn
      }
    });
    setSubmitted(true);
    setDisplayEditUserDialog(false);

    close();
  }


  const close = () => {
    setDisplayEditUserDialog(false);
  }

  return(
    <Modal
      open={displayEditUserDialog}
      onClose={() => close()}
      title="Update User"
      primaryAction={{
        content: 'Update User',
        onAction: () => submit(),
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: () => close()
        },
      ]}
    >
      <Modal.Section>
        <BlockStack gap="400">
          <Text as="h3" variant="headingSm">User Details</Text>

          <Text as="p">
            {activeUser.email}
          </Text>

          <TextField
            label="Login Name"
            value={loginName}
            onChange={setLoginName}
            placeholder="Login Name"
            autoComplete="off"
            requiredIndicator
          />

          <Text as="h3" variant="headingSm">Permissions</Text>

          <Checkbox
            checked={picker}
            onChange={setPicker}
            label='Picker'
          />

          <Checkbox
            checked={packer}
            onChange={setPacker}
            label='Packer'
          />

          <Checkbox
            checked={stockReturn}
            onChange={setStockReturn}
            label='Stock Returns'
          />
        </BlockStack>
      </Modal.Section>
    </Modal>
  )
}

export default EditUserDialog;
